import { Box, CircularProgress, Menu, MenuItem, Typography } from '@mui/material';
import { isEmpty } from 'lodash';
import { PropsWithChildren, useEffect, useMemo, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import imageBackground from 'src/assets/images/background_new.jpg';
import { LOCALE_LANGUAGE_LIST } from 'src/constants/i18n';
import { ROLE_LEVEL } from 'src/constants/role';
import { useIsRequestPending } from 'src/hooks';
import { useAppSelector } from 'src/redux_store';
import { systemTitle } from 'src/utils/common';
import { getParamToNavigate, getStationMapRoute } from 'src/utils/helper';
import en from '../../assets/images/en-us-flag-small.png';
import vi from '../../assets/images/vi-flag-small.png';
import { useStyles } from './style';
import Cookies from 'js-cookie';
import config from 'src/config';
import { useTranslation } from 'react-i18next';

const AuthLayout = ({ children }: PropsWithChildren) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const { t } = useTranslation();
  const classes = useStyles();

  const { me, token, role, customerId } = useAppSelector((state) => state.myAccountSlice);

  const isLoadingGetMe = useIsRequestPending('myAccount', 'getMe');

  const locale = localStorage.getItem('i18nextLng') || 'en';

  const [localeSelected, setLocaleSelected] = useState<string>('vi');

  useEffect(() => {
    const locale = localStorage.getItem('i18nextLng') || 'en';
    setLocaleSelected(locale);
  }, []);

  const location = useLocation() as any;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const currentPath = useMemo(
    () => location.state?.from?.pathname + location.state?.from?.search,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  useEffect(() => {
    document.title = systemTitle;
  }, []);

  const handleChangeLocale = (language: string) => {
    if (localeSelected !== language) {
      localStorage.setItem('i18nextLng', language);
      Cookies.set('locale', language, { path: '/', domain: config.domain });
      window.location.reload();
    } else {
      setAnchorEl(null);
    }
  };

  // loading get me action
  if (isLoadingGetMe) {
    return (
      <Box className={classes.center}>
        <CircularProgress color="error" />
      </Box>
    );
  }

  // if have token redirect to admin page

  if (token && !isEmpty(me)) {
    let from = getStationMapRoute(customerId);

    if (currentPath) {
      from = currentPath;
    } else {
      if (role.level === ROLE_LEVEL.SUPER_ADMIN || role.level === ROLE_LEVEL.SYSTEM_ADMIN) {
        // from = PATH.stationMap;
      } else {
        from = getParamToNavigate(me, role, customerId);
      }
    }

    return <Navigate to={from} replace />;
  }

  return (
    <Box
      className={classes.root}
      sx={{
        backgroundImage: `url(${imageBackground})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          zIndex: '2',
          right: '1.5%',
          top: '2.5%',
          cursor: 'pointer',
        }}
      >
        <Box
          onClick={(e: any) => {
            handleClick(e);
          }}
        >
          <img
            src={locale === 'vi' ? vi : en}
            alt="locate"
            style={{
              width: '32px',
              height: '32px',
              objectFit: 'cover',
              borderRadius: '50%',
            }}
          />
        </Box>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
        >
          {LOCALE_LANGUAGE_LIST(t).map((item) => {
            return (
              <MenuItem
                onClick={() => handleChangeLocale(item.id)}
                key={item.id}
                selected={item.id === localeSelected}
              >
                <Box display={'flex'} gap={1.5} alignItems={'center'}>
                  <img width={'25px'} alt="Danapod" src={item.flag} />
                  <Typography>{item.name}</Typography>
                </Box>
              </MenuItem>
            );
          })}
        </Menu>
      </Box>
      {children}
    </Box>
  );
};

export default AuthLayout;
